import axios from 'axios';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { MdTableBar, MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";
import { startTransition } from 'react';
import { FaUtensils } from "react-icons/fa";
import placeholder from '../assets/images/1080.png'
import JoditEditor from 'jodit-react';
import Select from 'react-select'

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'
import { RiPencilFill } from "react-icons/ri";

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    ONE,
    STATUS_200,
    NULL,
    ZERO,
    REGISTER_VENDOR_END_POINT
} = _constantUtil;

function SignUp() {

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const [profileImage, setProfileImage] = useState(placeholder);
    const [formData, setFormData] = useState({
        business_name: emptyString,
        location: [],
        website: emptyString,
        priceMin: emptyString,
        priceMax: emptyString,
        personal_email: emptyString,
        personal_contact: emptyString,
        personal_insta: emptyString,
        password: emptyString,
        password_confirmation: emptyString,
    });

    const [services, setServices] = useState([
        {
            id: Date.now(),
            image: placeholder,
            name: 0,
        },
    ]);

    const [content, setContent] = useState(emptyString);
    const [errors, setErrors] = useState({});
    const fileInputRef = useRef(NULL);

    const navigate = useNavigate();
    const [selected, setSelected] = useState(ONE);

    // * location array
    const locationArray = [
        'Eastern Cape', 'Free State',
        'Gauteng', 'KwaZulu-Natal',
        'Limpopo', 'Mpumalanga',
        'Northern Cape', 'North West',
        'Western Cape'
    ];

    // * location options
    const locationOptions = locationArray.map((loc) => ({
        value: loc,
        label: loc,
    }));

    // * handle checkbox change
    const handleCheckboxChange = (value) => {
        setSelected(value);
        setServices([
            {
                id: Date.now(),
                image: placeholder,
                name: 0,
            },
        ]);
    };

    //* handle change for textarea
    const handleChange = (e) => {
        const text = e.target.value;
        const wordCount = text.trim().split(/\s+/).filter(Boolean).length;

        if (wordCount <= 300) {
            setContent(text);
        }
    };

    // * handle image change
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
        const maxSize = 2 * 1024 * 1024; // 2MB

        const newImages = [];
        let invalidTypeFound = false;
        let invalidSizeFound = false;

        files.forEach((file) => {
            if (!allowedTypes.includes(file.type)) {
                invalidTypeFound = true;
            } else if (file.size > maxSize) {
                invalidSizeFound = true;
            } else {
                newImages.push({
                    file,
                    preview: URL.createObjectURL(file),
                });
            }
        });

        if (invalidTypeFound) {
            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        }
        if (invalidSizeFound) {
            toast.error("Each image must be 2MB or smaller.");
        }

        setImages((prevImages) => {
            const totalImages = prevImages.length + newImages.length;

            if (totalImages > 20) {
                toast.error("Maximum 20 images are allowed.");
                const allowedToAdd = 20 - prevImages.length;
                return [...prevImages, ...newImages.slice(0, allowedToAdd)];
            }

            return [...prevImages, ...newImages];
        });

        // ✅ Reset input to allow same file re-selection
        e.target.value = null;
    };

    // * handle remove image
    const handleRemoveImage = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    // * handle upload click
    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // * handle profile image 
    const handleProfileImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(URL.createObjectURL(file));
        }
    };

    // * handle form data change
    const handleFormDataChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // * handle add service  
    const handleAddService = () => {
        // Validate all existing services before adding
        for (let i = 0; i < services.length; i++) {
            const service = services[i];

            if (!service.name || service.name === 0 || service.name === "") {
                toast.error(`Service ${i + 1}: Name is required`, {
                    toastId: `name-required-${i}`,
                });
                return;
            }

            if (!service.image || service.image === placeholder) {
                toast.error(`Service ${i + 1}: Image is required`, {
                    toastId: `image-required-${i}`,
                });
                return;
            }
        }

        // All existing services are valid → Add new one
        const newService = {
            id: Date.now(),
            image: placeholder,
            name: 0,
        };

        setServices([...services, newService]);
    };

    //* Remove Service
    const handleRemoveService = (id) => {
        if (services.length === 1) {
            return;
        }

        const updatedServices = services.filter(service => service.id !== id);
        setServices(updatedServices);
    };

    //* handle file change
    const handleFileChange = (e, id) => {
        const updatedServices = services.map((service) => {
            if (service.id === id) {
                return { ...service, image: URL.createObjectURL(e.target.files[0]) };
            }
            return service;
        });
        setServices(updatedServices);
    };

    //* handle input change
    const handleInputChange = (e, id, field) => {
        const { value } = e.target;
        setServices(prev =>
            prev.map(service =>
                service.id === id ? { ...service, [field]: value } : service
            )
        );
    };

    // * validation.js
    const validateForm = () => {
        const errors = {};

        // Business name required
        if (!formData.business_name.trim()) {
            errors.business_name = "Business name is required";
        }

        // Location required (array check)
        if (!formData.location || formData.location.length === 0) {
            errors.location = "Location is required";
        }

        // Website (optional but if provided must be valid URL)
        if (!formData.website) {
            errors.website = "Website is required";
        }

        if (!images) {
            errors.images = "Business Images is required"
        }

        // Email required + valid
        if (!formData.personal_email.trim()) {
            errors.personal_email = "Email is required";
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(formData.personal_email)
        ) {
            errors.personal_email = "Email is not valid";
        }

        // Contact optional but if provided check digits
        if (formData.personal_contact && !/^\d{10,15}$/.test(formData.personal_contact)) {
            errors.personal_contact = "Contact number should be 10–15 digits";
        }

        // Instagram handle optional but must start with @ or url
        if (formData.personal_insta && !/^@?[\w\.]{1,30}$/.test(formData.personal_insta)) {
            errors.personal_insta = "Instagram handle not valid";
        }

        if (!profileImage) {
            errors.profileImage = "Profile image is required"
        }

        // Price min/max numeric check
        if (formData.priceMin && isNaN(formData.priceMin)) {
            errors.priceMin = "Minimum price must be a number";
        }
        if (formData.priceMax && isNaN(formData.priceMax)) {
            errors.priceMax = "Maximum price must be a number";
        }
        if (
            formData.priceMin &&
            formData.priceMax &&
            Number(formData.priceMin) > Number(formData.priceMax)
        ) {
            errors.priceMax = "Maximum price must be greater than minimum price";
        }

        // Password required
        if (!formData.password) {
            errors.password = "Password is required";
        } else if (formData.password.length < 6) {
            errors.password = "Password must be at least 6 characters";
        }

        // Confirm password
        if (formData.password_confirmation !== formData.password) {
            errors.password_confirmation = "Passwords do not match";
        }

        return setErrors(errors);
    };

    // * execute register api
    const executeRegisterApi = async (e) => {
        e.preventDefault();

        if (profileImage === placeholder) {
            toast.error("Profile image is required.");
            return;
        }
        if (images.length < 3) {
            toast.error("Please upload at least 3 images.");
            return;
        }

        // * set loading and disable button
        setLoading(trueValue);
        setDisableButton(trueValue);

        // * create form data
        const data = new FormData();
        const img = document.getElementById('upload-photo');
        data.append('category', selected);
        data.append('name', formData.business_name);
        data.append('image', img.files[0]);
        data.append('description', content);
        data.append('location', JSON.stringify(formData.location));
        data.append('email', formData.personal_email);
        data.append('phone', formData.personal_contact);
        data.append('insta', formData.personal_insta);
        data.append('website', formData.website);
        data.append('password', formData.password);
        data.append('password_confirmation', formData.password_confirmation);

        for (const service of services) {
            data.append('service_name[]', service.name);

            if (service.image) {
                const response = await fetch(service.image);
                const blob = await response.blob();
                const file = new File([blob], `service_${service.name}.jpg`, { type: blob.type });
                data.append('service_image[]', file);
            } else {
                data.append('service_image[]', '');
            }
        }

        const image = images.map(item => item.file);
        image.forEach((img) => {
            data.append('business_images[]', img);
        });

        try {
            const apiUrl = `${config.appBaseUrl + REGISTER_VENDOR_END_POINT}`;

            // * execute put request
            const response = await axios.post(apiUrl, data, {
                headers: {
                    Authorization: `Bearer`,
                },
            });

            // * api response
            const apiResponse = response.data;

            // * if response is success
            if (apiResponse.status && apiResponse.code === STATUS_200) {
                toast.success(apiResponse.message);
                setTimeout(() => {
                    navigate('/dashboard');
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 1400);
                localStorage.setItem('vendor_dashboard', apiResponse.data.token);
                localStorage.setItem('vendor_dashboard_name', apiResponse.data.vendor.name);
                localStorage.setItem('vendor_dashboard_email', apiResponse.data.vendor.email);
                localStorage.setItem('vendor_dashboard_image', apiResponse.data.vendor.image);
                localStorage.setItem('vendor_dashboard_status', apiResponse.data.vendor.status);
            } else {
                toast.error(apiResponse.message);
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        } catch (error) {
            handleError(error);
            setLoading(falseValue);
            setDisableButton(falseValue);
        }
    };

    //* handle error
    const handleError = (error) => {
        const errorData = error.response?.data?.data;

        if (errorData && typeof errorData === "object") {
            const firstKey = Object.keys(errorData)[0];
            const firstMessage = errorData[firstKey][0];
            toast.error(firstMessage);
        } else {
            toast.error("Something was broken!");
        }
    };

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className="grid">
                {/* //* left side content */}
                <div className="order__left centered" >
                    <form className="form" onSubmit={executeRegisterApi}>
                        <div className="logo text-center">
                            <h3 >Hire a Vendor for professionals</h3>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text-center'>Create an account or log in to manage your business.</p>
                        </div>

                        <div className="row">

                            {/* //* mobile bar category */}
                            <div className="col-12 col-md-6 mb-3 mb-md-0">
                                <li
                                    className={`sign-up-card mb-0 ${selected === 1 ? 'golder-border' : ''}`}
                                    onClick={() => handleCheckboxChange(1)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <MdTableBar size={40} />
                                        <h2>Mobile Bar</h2>
                                        <label className="checkbox-control m-0">
                                            <input
                                                type="checkbox"
                                                className="checkbox"
                                                checked={selected === 1}
                                                readOnly
                                            />
                                        </label>
                                    </div>
                                </li>
                            </div>

                            {/* //* caterer category */}
                            <div className="col-12 col-md-6 mb-0">
                                <li
                                    className={`sign-up-card mb-0 ${selected === 2 ? 'golder-border' : ''}`}
                                    onClick={() => handleCheckboxChange(2)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <FaUtensils size={40} />
                                        <h2>Caterer</h2>
                                        <label className="checkbox-control m-0">
                                            <input
                                                type="checkbox"
                                                className="checkbox"
                                                checked={selected === 2}
                                                readOnly
                                            />
                                        </label>
                                    </div>
                                </li>
                            </div>

                            {/* //* business name */}
                            <div className="col-12 col-md-12 mb-3">
                                <input
                                    type="text"
                                    id="business_name"
                                    name="business_name"
                                    placeholder="Enter business name"
                                    className="form-control mb-0"
                                    autoComplete="off"
                                    value={formData.business_name}
                                    onChange={handleFormDataChange}
                                    required
                                />
                                {errors.business_name && <p className='text-danger my-1'>{errors.business_name}</p>}
                            </div>

                            {/* //* location */}
                            <div className="col-12 col-md-12 mb-0">
                                <Select
                                    id="location"
                                    name="location"
                                    placeholder="Select locations"
                                    options={locationOptions}
                                    isMulti
                                    className='basic-multi-select'
                                    value={locationOptions.filter(opt => formData.location.includes(opt.value))}
                                    onChange={(selectedOptions) =>
                                        handleFormDataChange({
                                            target: {
                                                name: 'location',
                                                value: selectedOptions.map((opt) => opt.value),
                                            },
                                        })
                                    }
                                    required
                                />
                                {errors.location && <p className='text-danger my-1'>{errors.location}</p>}
                            </div>

                            {/* //* website */}
                            <div className="col-12 col-md-12 my-3">
                                <input
                                    type="url"
                                    id="website"
                                    name="website"
                                    placeholder="Enter website"
                                    className="form-control mb-0"
                                    style={{ width: "100%", }}
                                    value={formData.website}

                                    onChange={handleFormDataChange}
                                    required
                                />
                                <p className='small my-1 mb-0'><strong>Note: </strong>e.g. https://example.com</p>
                            </div>

                            {/* //* upload maximum 20 images */}
                            <div className="col-12 col-md-12 mb-3">
                                <div className='card mb-0'>
                                    <div className='card-body'>
                                        <div className={`d-flex align-items-center justify-content-center rounded-2 ${services.length > ZERO && 'mb-3'} px-3 py-2`} style={{ background: '#e8fff4' }}>
                                            <label htmlFor="email" className="mb-0 fw-semibold">Upload Business Images</label>
                                        </div>
                                        <div
                                            onClick={handleUploadClick}
                                            className="d-flex flex-column align-items-center justify-content-center"
                                            style={{
                                                border: '2px dashed #aaa',
                                                borderRadius: '10px',
                                                padding: '20px',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                backgroundColor: '#f9f9f9',
                                                transition: 'all 0.3s ease-in-out',
                                            }}
                                        >
                                            {images.length === 0 ? (
                                                <div>
                                                    <strong>Click to upload business images.</strong>
                                                    <p className="mb-0">Upload minimum 3 and maximum 20 images</p>
                                                </div>
                                            ) : (
                                                <>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '10px',
                                                            justifyContent: 'center',
                                                            marginBottom: '10px',
                                                        }}
                                                    >
                                                        {images.map((img, index) => (
                                                            <div key={index} style={{ position: 'relative' }}>
                                                                <img
                                                                    src={img.preview}
                                                                    alt="preview"
                                                                    width="80"
                                                                    height="80"
                                                                    style={{ objectFit: 'cover', borderRadius: '8px' }}
                                                                />
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleRemoveImage(index);
                                                                    }}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-5px',
                                                                        right: '-5px',
                                                                        background: 'red',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '50%',
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        fontSize: '14px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    ×
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div>
                                                        <strong>Click to upload more images</strong>
                                                        <p className="mb-0">You can upload {20 - images.length} more images</p>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <input
                                            type="file"
                                            multiple
                                            accept=".jpg,.jpeg,.png,.webp"
                                            ref={fileInputRef}
                                            onChange={handleImageChange}
                                            className="file-input-hidden"
                                            name='multiple-image'
                                        />

                                    </div>
                                    {errors.website && <p className='text-danger my-1'>{errors.website}</p>}
                                    <div className='d-flex p-3 pt-0'>
                                        <strong className='mb-0'>Note: </strong>
                                        <p className="mb-0 small">&nbsp;You can upload images in JPG, JPEG, PNG, or WEBP format only.</p>
                                    </div>
                                </div>
                            </div>

                            {/* //* services */}
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="p-6 bg-gray-50 min-h-screen flex flex-col items-center">
                                            <div className={`d-flex align-items-center justify-content-center rounded-2 ${services.length > ZERO && 'mb-3'} px-3 py-2`} style={{ background: '#e8fff4' }}>
                                                <label htmlFor="email" className="mb-0 fw-semibold">Add 5 Popular Services</label>
                                            </div>

                                            <div className="row">
                                                {services.map((service, index) => (
                                                    <div key={service.id} className="col-12 col-md-12">
                                                        <div className="bg-white p-6 rounded-lg shadow w-full max-w-lg space-y-4 relative">

                                                            {/* //* Remove button */}
                                                            {services.length > 1 && (
                                                                <button
                                                                    className="btn bg-danger close-vendor-btn text-white p-1 rounded-circle"
                                                                    onClick={() => handleRemoveService(service.id)}
                                                                >
                                                                    ✕
                                                                </button>
                                                            )}

                                                            <div className="p-3 mb-4 d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-start gap-3">
                                                                <div
                                                                    style={{
                                                                        position: 'relative',
                                                                        width: '100%',
                                                                        aspectRatio: '4 / 3',
                                                                        marginTop: '6px',
                                                                        maxWidth: '150px'
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={service.image}
                                                                        alt="Service"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '8px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => document.getElementById(`upload-photo-${service.id}`).click()}
                                                                    />
                                                                    <label
                                                                        htmlFor={`upload-photo-${service.id}`}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '-8px',
                                                                            left: '-10px',
                                                                            background: '#fff',
                                                                            borderRadius: '50%',
                                                                            padding: '3px 6px',
                                                                            fontSize: '13px',
                                                                            cursor: 'pointer',
                                                                            boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                                                                            transform: 'rotate(254deg)',
                                                                        }}
                                                                    >
                                                                        🖉
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        id={`upload-photo-${service.id}`}
                                                                        style={{ display: 'none' }}
                                                                        accept="image/*"
                                                                        onChange={(e) => handleFileChange(e, service.id)}
                                                                    />
                                                                </div>

                                                                <div className="row mt-1 w-100">
                                                                    <div className="col-12 col-md-12 px-0 px-md-2">
                                                                        <label htmlFor={`Name-${service.id}`}>Service Name</label>
                                                                        <input
                                                                            type="text"
                                                                            name="Name"
                                                                            id={`Name-${service.id}`}
                                                                            className="form-control m-0 font-size-16"
                                                                            value={service.name || ''}
                                                                            onChange={(e) => handleInputChange(e, service.id, 'name')}
                                                                            required
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {(services.length < 5) && (
                                                    <div className='d-flex align-items-center justify-content-end'>
                                                        <button className="btn btn-success w-auto " onClick={handleAddService}>
                                                            Add more
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* //* tags */}
                            {/* <div className=' col-12 col-md-12 mb-3'>
                                <Select
                                    isMulti
                                    name="service"
                                    options={tagOptions}
                                    value={selectedTags}
                                    className="basic-multi-select"
                                    placeholder="Select tags..."
                                    classNamePrefix="select"
                                    onChange={(selectedOptions) => {
                                        setSelectedTags(selectedOptions);
                                    }}
                                />
                            </div> */}

                            {/* //* personal info */}
                            <div className="row align-items-center mb-3">
                                <div className="custom-card-signup w-100">
                                    {/* Title */}
                                    <div className="d-flex mb-2">
                                        <h5 className="mb-0">Personal Info</h5>
                                    </div>

                                    {/* //* Content - Image Left, Inputs Right */}
                                    <div className="row w-100 align-items-center">

                                        {/* //* Left side - Profile Image */}
                                        <div className="col-12 col-md-4 mb-3 mb-md-0 d-flex justify-content-center">
                                            <div style={{ position: 'relative', width: '150px', height: '150px', marginTop: '6px' }}>
                                                <img
                                                    src={profileImage} // Default image
                                                    alt="Profile"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        border: '2px solid #ccc',
                                                        borderRadius: '8px',
                                                    }}
                                                />
                                                <label
                                                    htmlFor="upload-photo"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-8px',
                                                        right: '-13px',
                                                        background: '#fff',
                                                        borderRadius: '50%',
                                                        padding: '3px 6px',
                                                        fontSize: '13px',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                                                    }}
                                                >
                                                    <RiPencilFill size={16} />
                                                </label>
                                                <input
                                                    type="file"
                                                    id="upload-photo"
                                                    style={{ display: 'none' }}
                                                    accept="image/*"
                                                    onChange={handleProfileImage}
                                                />
                                                {errors.profileImage && <p className='text-danger my-1'>{errors.profileImage}</p>}
                                            </div>
                                        </div>

                                        {/* //* Right side - Inputs */}
                                        <div className="col-12 col-md-8 pe-0">
                                            <div className="row">

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="email"
                                                        id="personal_email"
                                                        name="personal_email"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter email"
                                                        autoComplete="off"
                                                        value={formData.personal_email}
                                                        onChange={handleFormDataChange}
                                                        required
                                                    />
                                                    {errors.personal_email && <p className='text-danger my-1'>{errors.personal_email}</p>}
                                                </div>

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="number"
                                                        id="personal_contact"
                                                        name="personal_contact"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter contact number"
                                                        autoComplete="off"
                                                        value={formData.personal_contact}
                                                        onChange={handleFormDataChange}
                                                        required
                                                    />
                                                    {errors.personal_contact && <p className='text-danger my-1'>{errors.personal_contact}</p>}
                                                </div>

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="text"
                                                        id="personal_insta"
                                                        name="personal_insta"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter instagram id"
                                                        value={formData.personal_insta}
                                                        onChange={handleFormDataChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {errors.personal_insta && <p className='text-danger my-1'>{errors.personal_insta}</p>}
                                                </div>

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="text"
                                                        id="password"
                                                        name="password"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter password"
                                                        value={formData.password}
                                                        onChange={handleFormDataChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {errors.password && <p className='text-danger my-1'>{errors.password}</p>}
                                                </div>

                                                <div className="col-12 pe-0">
                                                    <input
                                                        type="text"
                                                        id="password_confirmation"
                                                        name="password_confirmation"
                                                        className="form-control mb-0"
                                                        style={{ padding: '5px 10px', }}
                                                        placeholder="Enter confirm password"
                                                        value={formData.password_confirmation}
                                                        onChange={handleFormDataChange}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {errors.password_confirmation && <p className='text-danger my-1'>{errors.password_confirmation}</p>}
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* //* text editor for description */}
                            <div className="col-12 mb-3">
                                <textarea
                                    value={content}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows={4}
                                    placeholder="Enter description (max 300 words)"
                                    required
                                />
                                <div className="text-end text-sm text-gray-500 mt-1">
                                    {content.trim().split(/\s+/).filter(Boolean).length} / 300 words
                                </div>
                            </div>

                        </div>

                        <button
                            type="submit"
                            className="login__button"
                            disabled={disableButton}
                        >
                            {!loading ? 'Sign up' : <Loader />}
                        </button>

                        <div className="signup">
                            <label className="remember_me">Already have an account?</label>
                            <Link
                                to="/login"
                                className="forgot__password text-golden"
                                style={{ textDecoration: "none" }}
                            >
                                <strong>Login</strong>
                            </Link>
                        </div>

                    </form>
                </div>

                {/* //* right side image */}
                <div className="order__right centered no__overflow">
                    <img
                        className="img"
                        src={mobileBar}
                        alt="picture"
                    />
                </div>
            </div>
        </>
    );
}

export default SignUp;
